import { Head as Helmet } from 'vite-react-ssg';

interface SchemaOrgProps {
    schema: Record<string, any>;
}

export const SchemaOrg = ({ schema }: SchemaOrgProps) => {
    try {
        if (!schema || typeof schema !== 'object') {
            return null;
        }

        const json = JSON.stringify(schema);
        return (
            <Helmet>
                <script type="application/ld+json">
                    {json}
                </script>
            </Helmet>
        );
    } catch (e) {
        console.error('SchemaOrg JSON stringify error:', e);
        return null;
    }
};
